import { distinctUntilChanged } from 'rxjs/operators';
import { isEqual as isEqual$1 } from 'lodash-es';

function isEqual() {
    // tslint:disable-next-line:only-arrow-functions
    return function (source) {
        return source.pipe(distinctUntilChanged((oldValue, newValue) => {
            return isEqual$1(oldValue, newValue);
        }));
    };
}

/**
 * Generated bundle index. Do not edit.
 */

export { isEqual };
